<div class="row">
  <div class="col">
    <h2>Confirmation</h2>

    <p>
      Thank you! You have successfully started the application process. A
      representative from Eagle will contact you within one business day
      regarding your application.
    </p>
    <p>
      For reference, your information was sent to our
      {{ branch?.LocationName }} branch.
    </p>
    <p>
      If approved, you will need to visit one of our branches to close your
      loan.
    </p>
    <p>
      Questions? Contact {{ branch?.LocationName }} - we&rsquo;re here to help!
    </p>
  </div>
</div>

<div *ngIf="branch" class="row mt-3">
  <div class="col-12 col-md-6 col-lg-4">
    <app-branch-selection [branch]="branch"></app-branch-selection>
  </div>
</div>
